import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DataGrid } from '@mui/x-data-grid';

function DiscrepancyTable(props) {

    const columns = [
        {
            field: 'acu_order_num',
            headerName: 'Acumatica Order Number',
            flex: 1,
            minWidth: 85,
            editable: false
        },
        {
            field: 'timestamp',
            headerName: 'Date',
            flex: 1,
            minWidth: 125,
            editable: false
        },
        {
            field: 'from_warehouse',
            headerName: 'From WH',
            flex: 1,
            minWidth: 80,
            editable: false
        },
        {
            field: 'to_warehouse',
            headerName: 'To WH',
            flex: 1,
            minWidth: 80,
            editable: false
        },
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1,
            minWidth: 125,
            editable: false
        },
        {
            field: 'shipped',
            headerName: 'Shipped',
            flex: 1,
            minWidth: 80,
            editable: false
        },
        {
            field: 'received',
            headerName: 'Received',
            flex: 1,
            minWidth: 80,
            editable: false
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 100,
            editable: false
        },
        {
            field: 'notes',
            headerName: 'Notes',
            flex: 1,
            minWidth: 200,
            editable: false
        },
    ];

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
        <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <Stack direction = 'row' sx = {{width: '95%'}} spacing = {2}> 
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#faa0a0', 
                            '&:hover': {
                                backgroundColor: '#b87474',  
                            },
                        },
                        '& .green-row': {
                            backgroundColor: '#91ba91', 
                            '&:hover': {
                                backgroundColor: '#526952',  
                            },
                        },
                    }}
                    rows = {props.discrepancies ? props.discrepancies : []}
                    getRowId = {(row) => row.id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {true}
                    selectionModel = {props.selectedIndex}
                    onSelectionModelChange = {(selectionModel, details) => {
                        props.handleSelect(selectionModel)
                    }}
                    getRowClassName = {(discrepancy) =>
                        discrepancy.row.status === 'Unresolved' ? 'red-row' : 'green-row'
                    }
                />
                <Tooltip title = {"Export Discrepancies."}  sx = {{ width: '1000px' }} placement = "right-start" >
                    <span>
                        <IconButton 
                            aria-label = "exportDiscrepancies" 
                            onClick = {props.exportDiscrepancies} 
                            sx = {{ mt: '5px', color: '#96605a' }}>
                            <FileDownloadIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Stack>
        </Box>
    </Box>
    )
}

export default DiscrepancyTable;